import { History } from "lucide-react";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { VacancyHistoryEntryItem } from ".";
import { useVacancyHistory } from "../../api/useVacancyHistory";

import EmptyState from "@/components/ui/v2/empty-state";
import {
  getFromDate,
  HistoryTimeline,
  type RangePreset,
} from "@/components/ui/v2/history";

export function VacancyHistoryTab({
  vacancyId,
}: {
  vacancyId: number;
}) {
  const { t } = useTranslation();
  const [preset, setPreset] = useState<RangePreset>("30d");
  const anchorNow = useMemo(() => new Date(), []);
  const pageSize = 30;
  const from = useMemo(() => getFromDate(preset, anchorNow), [preset, anchorNow]);

  const historyResult = useVacancyHistory({
    vacancyId: vacancyId.toString(),
    from,
    to: undefined,
    pageSize,
  });

  if (!vacancyId) {
    return (
      <EmptyState
        icon={History}
        title={t("admin.vacancies.history.noVacancyTitle")}
        description={t("admin.vacancies.history.noVacancyDescription")}
      />
    );
  }

  return (
    <HistoryTimeline
      useHistoryResult={historyResult}
      renderEntry={(entry) => <VacancyHistoryEntryItem entry={entry} />}
      i18nPrefix="admin.vacancies.history"
      preset={preset}
      onPresetChange={setPreset}
    />
  );
}
